import { render, staticRenderFns } from "./ModuloList.vue?vue&type=template&id=d70ca00c"
import script from "./ModuloList.vue?vue&type=script&lang=js"
export * from "./ModuloList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports